export default "__VITE_ASSET__cufUCVM9__"